import React from "react";
import Field from "./Field";
import PasswordControl from "./PasswordControl";
import { FieldProps } from "./Types";

const PasswordField: React.FC<FieldProps> = ({ labelProps, controlProps, visible, disabled }) => {

    if (visible === false)
        return <></>;

    return (
        <Field {...labelProps}>
            <PasswordControl {...controlProps} disabled={disabled} />
        </Field>
    );
}
export default PasswordField;